const actionTypes = {
  SET_MESSAGE: 'setBulkRevisionSendEditMessage',
  SET_MESSAGE_ERROR: 'setBulkRevisionSendEditMessageError',
  SET_TABLE_LIST: 'setBulkRevisionSendEditTableList',
  SET_HANDLE_FLAG: 'setHandleFlag',
  SET_SELECTED_ITEM: 'setSelectedItem',
}

export default actionTypes
